// extracted by mini-css-extract-plugin
export const mobileShare = "mobileSocial-module--mobileShare--3hH5h";
export const active = "mobileSocial-module--active--tWbHF";
export const mobileShareClick = "mobileSocial-module--mobileShareClick--fhQlz";
export const mobileSharePosition = "mobileSocial-module--mobileSharePosition--3fCcG";
export const socialIcon = "mobileSocial-module--socialIcon--13-yy";